document.addEventListener("DOMContentLoaded", function () {

  const tabButtons = document.querySelectorAll(".tab_button");
  const tabContents = document.querySelectorAll(".tab_content_content");

  tabButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      const buttonIndex = this.getAttribute("data-tab-button-index");

      tabButtons.forEach(btn => btn.classList.remove("active_button"));

      tabContents.forEach(content => content.classList.remove("active_content"));

      this.classList.add("active_button");

      const activeContent = document.querySelector(
        `.tab_content_content[data-tab-content-index="${buttonIndex}"]`
      );

      if (activeContent) {
        activeContent.classList.add("active_content");
      }

      

    });
  });

});